<template>
  <FlashMessage
    :position="position"
    class="io-alerts-wrapper"
    :class="{
      'io-alerts-wrapper--desktop': isDesktop,
      'io-alerts-wrapper--pwa': pwaActive,
    }"
  />
</template>

<script>
import { storeToRefs } from 'pinia';

import { useCenterPwaStore } from '@/apps/center/stores/pwa';
import { latin1ToHex } from '@/utils/Binary';

export default {
  name: 'IoAlerts',

  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    position: {
      type: String,
      default: () => 'right bottom',
    },
  },

  setup() {
    const pwaStore = useCenterPwaStore();
    const { isActive: pwaActive, isDesktop } = storeToRefs(pwaStore);

    return {
      isDesktop,
      pwaActive,
    };
  },

  data() {
    return {
      disableAlerts: false,
    };
  },

  mounted() {
    if (window.__ioAlertalreadyEchoedMessages === undefined) {
      window.__ioAlertalreadyEchoedMessages = [];
    }

    if (!window.alertsInitialized) {
      this.flashMessage.setStrategy('multiple');

      if (this.messages.length > 0) {
        this.echoMessages(this.messages);
      }

      window.GlobalEvents.listen('alert', (messages) => {
        const messagesHash = this.getHash(messages);
        const alreadyEchoed = (window.__ioAlertalreadyEchoedMessages || []).includes(messagesHash);

        if (alreadyEchoed) return;

        window.__ioAlertalreadyEchoedMessages.push(messagesHash);

        this.echoMessages(messages);
      });

      window.alertsInitialized = true;
    } else {
      this.disableAlerts = true;
      window.alertsInitialized = true;
    }
  },

  methods: {
    getHash(data) {
      const dataObject = {
        messages: data || [],
        firedAt: new Date().format('d.m.Y-H:i:s'),
      };
      const jsonString = JSON.stringify(dataObject).replace(/\s+/g, '');

      return latin1ToHex(jsonString);
    },
    echoMessages(messages) {
      if (this.disableAlerts) return;

      Object.values(messages).forEach((message) => {
        this.flashMessage.show({
          status: message.type,
          html: `
              <div class="_vue-flash-msg-body__content">
                  ${typeof message.title !== 'undefined' ? (`<h6>${message.title}</h6>`) : ''}
                  <p>
                      ${message.message}
                  </p>
              </div>
          `,
          wrapperClass: 'io-alerts',
          blockClass: 'io-alert',
          time: message.time || 8000,
        }, {
          mounted: () => {
            this.$emit('mounted');
            this.disableAlerts = true;
          },
          destroyed: () => {
            this.$emit('destroyed');
            this.disableAlerts = false;
            this.alerts = [];
          },
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.io-alerts-wrapper {
  &:not(&.io-alerts-wrapper--desktop) {
    &:deep(._vue-flash-msg-_right-bottom.io-alert) {
      bottom: 80px !important;
    }

    &.io-alerts-wrapper--pwa:deep(._vue-flash-msg-_right-bottom.io-alert) {
      bottom: 100px !important;
    }
  }
}
</style>
